import { useCallback, useEffect, useState } from 'react';
import { useIs2xlUp } from './useMediaQuery';

export const PROFILE_GUIDANCE_COLLAPSED_KEY = 'profileGuidanceCollapsed';

function readStoredCollapsed() {
  if (typeof window === 'undefined') return null;
  const stored = window.localStorage.getItem(PROFILE_GUIDANCE_COLLAPSED_KEY);
  if (stored === 'true') return true;
  if (stored === 'false') return false;
  return null;
}

/** Below 2xl defaults collapsed; wide desktop defaults open until the user chooses otherwise. */
export function useProfileGuidanceCollapse() {
  const isWide = useIs2xlUp();
  const [collapsed, setCollapsed] = useState(() => {
    const stored = readStoredCollapsed();
    if (stored !== null) return stored;
    if (typeof window !== 'undefined') {
      return !window.matchMedia('(min-width: 1536px)').matches;
    }
    return true;
  });

  useEffect(() => {
    if (readStoredCollapsed() !== null) return;
    setCollapsed(!isWide);
  }, [isWide]);

  const setCollapsedPersist = useCallback((next) => {
    setCollapsed(next);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(PROFILE_GUIDANCE_COLLAPSED_KEY, next ? 'true' : 'false');
    }
  }, []);

  const expand = useCallback(() => setCollapsedPersist(false), [setCollapsedPersist]);
  const collapse = useCallback(() => setCollapsedPersist(true), [setCollapsedPersist]);

  return {
    collapsed,
    isWide,
    isExpanded: !collapsed,
    setCollapsed: setCollapsedPersist,
    expand,
    collapse,
  };
}
